module.exports = __webpack_public_path__ + "static/media/06.c1ae3f72.jpg";